import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-book-open-line text-2xl" style={{ color: 'oklch(var(--primary-400))' }}></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">
                  韩漫网
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                韩漫网提供韩漫漫画免费阅读服务，无删减韩漫下拉式免费在线阅读。环境纯净无弹窗广告，海量韩漫资源每日更新。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                快速导航
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    漫画分类
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                热门分类
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link to="/category/romance" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    恋爱韩漫
                  </Link>
                </li>
                <li>
                  <Link to="/category/fantasy" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    奇幻韩漫
                  </Link>
                </li>
                <li>
                  <Link to="/category/action" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    动作韩漫
                  </Link>
                </li>
                <li>
                  <Link to="/category/thriller" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    悬疑韩漫
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                联系我们
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-xs"></i>
                  </div>
                  <span>contact@hanmanwang.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-customer-service-line text-xs"></i>
                  </div>
                  <span>在线客服：工作日 9:00-18:00</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 韩漫网 - 韩漫漫画免费阅读平台。本站所有漫画内容均来自互联网，仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
                使用条款
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}